import type { WavePlanningFixture, WaveWeek } from './model'

// Source: Copy of D26 Hall Wave Break Graph - 2026.xlsx, named subclass sheets.
// Extracted inputs only; results are recalculated in model.ts.
// No runtime workbook dependency. 2027 reuses these inputs as a demo.
export const WAVE_FIXTURES: WavePlanningFixture[] = [
  {
    id: '7156',
    name: 'Magic & Mischief',
    code: '26-0772-7156',
    description: 'SWEET & SPOOKY HE HALL',
    season: 'Halloween',
    stores: 1416,
    previousStores: null,
    skus: 49,
    previousSkus: null,
    pogSet: 98,
    pogMax: null,
    purchaseUnits: 300000,
    setDate: '2026-06-05',
    setWeek: 18,
    seasonEndWeek: 39,
    note: 'Actual set is week 19, planned 1-wk early based on divisional guidance',
    demand: [
      1, 1, 0, 0, 1, 0, 0, 0, 2, 0, 2, 0, 0, 2, 6236, 17573, 12687, 10348,
      10754, 9863, 10255, 12327, 13849, 13228, 13211, 18003, 20698, 18100,
      16045, 15117, 17928, 15954, 12249, 11159, 8640, 3324, 2892, 880, 0, 0, 0,
    ],
    historicalWaves: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    plannedWaves: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.78, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
  },
  {
    id: '5695',
    name: 'Hallowed Halls',
    code: '26-0772-5695',
    description: 'DEAD REGENCY HE HALL',
    season: 'Halloween',
    stores: 1416,
    previousStores: null,
    skus: 99,
    previousSkus: null,
    pogSet: 195,
    pogMax: null,
    purchaseUnits: 430000,
    setDate: '2026-07-10',
    setWeek: 23,
    seasonEndWeek: 39,
    note: null,
    demand: [
      0, 0, 0, 2, 2, 2, 0, 0, 0, 0, 2, 0, 0, 0, 2, 0, 0, 0, 0, 5706, 11946,
      23160, 25816, 27892, 26864, 32113, 34816, 28486, 29901, 30150, 34649,
      29059, 22631, 22562, 20120, 3233, 3736, 360, 0, 0, 0,
    ],
    historicalWaves: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    plannedWaves: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.87, 0, 0, 0, 0, 0,
      0.13, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
  },
  {
    id: '8826',
    name: 'Touch of Twilight',
    code: '26-0772-8826',
    description: 'IRIDESCENT MOON HE HALL',
    season: 'Halloween',
    stores: 1416,
    previousStores: null,
    skus: 68,
    previousSkus: null,
    pogSet: 135,
    pogMax: null,
    purchaseUnits: 300000,
    setDate: '2026-07-10',
    setWeek: 23,
    seasonEndWeek: 39,
    note: 'Actual set is week 24, planned 1-wk early based on divisional guidance',
    demand: [
      0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 2753, 5201,
      13435, 16160, 21069, 19917, 22129, 25306, 22444, 19923, 20608, 27140,
      21487, 17184, 15959, 13260, 978, 1312, 614, 0, 0, 0,
    ],
    historicalWaves: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    plannedWaves: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.87, 0, 0, 0, 0, 0,
      0.13, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
  },
]

export const REFERENCE_WEEKS: WaveWeek[] = [
  {
    week: 5,
    event: 'SEA5',
    date: '2026-03-06',
  },
  {
    week: 6,
    event: 'SEA6',
    date: '2026-03-13',
  },
  {
    week: 7,
    event: 'SEA7',
    date: '2026-03-20',
  },
  {
    week: 8,
    event: 'SEA8',
    date: '2026-03-27',
  },
  {
    week: 9,
    event: 'SEA9',
    date: '2026-04-03',
  },
  {
    week: 10,
    event: 'SEA10',
    date: '2026-04-10',
  },
  {
    week: 11,
    event: 'SEA11',
    date: '2026-04-17',
  },
  {
    week: 12,
    event: 'SEA12',
    date: '2026-04-24',
  },
  {
    week: 13,
    event: 'SEA13',
    date: '2026-05-01',
  },
  {
    week: 14,
    event: 'SEA14',
    date: '2026-05-08',
  },
  {
    week: 15,
    event: 'SEA15',
    date: '2026-05-15',
  },
  {
    week: 16,
    event: 'SEA16',
    date: '2026-05-22',
  },
  {
    week: 17,
    event: 'SEA17',
    date: '2026-05-29',
  },
  {
    week: 18,
    event: 'SEA18',
    date: '2026-06-05',
  },
  {
    week: 19,
    event: 'SEA19',
    date: '2026-06-12',
  },
  {
    week: 20,
    event: 'SEA20',
    date: '2026-06-19',
  },
  {
    week: 21,
    event: 'SEA21',
    date: '2026-06-26',
  },
  {
    week: 22,
    event: 'SEA22',
    date: '2026-07-03',
  },
  {
    week: 23,
    event: 'SEA23',
    date: '2026-07-10',
  },
  {
    week: 24,
    event: 'SEA24',
    date: '2026-07-17',
  },
  {
    week: 25,
    event: 'SEA25',
    date: '2026-07-24',
  },
  {
    week: 26,
    event: 'SEA26',
    date: '2026-07-31',
  },
  {
    week: 27,
    event: 'SEA27',
    date: '2026-08-07',
  },
  {
    week: 28,
    event: 'SEA28',
    date: '2026-08-14',
  },
  {
    week: 29,
    event: 'SEA29',
    date: '2026-08-21',
  },
  {
    week: 30,
    event: 'SEA30',
    date: '2026-08-28',
  },
  {
    week: 31,
    event: 'SEA31',
    date: '2026-09-04',
  },
  {
    week: 32,
    event: 'SEA32',
    date: '2026-09-11',
  },
  {
    week: 33,
    event: 'SEA33',
    date: '2026-09-18',
  },
  {
    week: 34,
    event: 'SEA34',
    date: '2026-09-25',
  },
  {
    week: 35,
    event: 'SEA35',
    date: '2026-10-02',
  },
  {
    week: 36,
    event: 'SEA36',
    date: '2026-10-09',
  },
  {
    week: 37,
    event: 'SEA37',
    date: '2026-10-16',
  },
  {
    week: 38,
    event: 'SEA38',
    date: '2026-10-23',
  },
  {
    week: 39,
    event: 'SEA39',
    date: '2026-10-30',
  },
  {
    week: 40,
    event: 'SEA40',
    date: '2026-11-06',
  },
  {
    week: 41,
    event: 'SEA41',
    date: '2026-11-13',
  },
  {
    week: 42,
    event: 'SEA42',
    date: '2026-11-20',
  },
  {
    week: 43,
    event: 'NO WAVE',
    date: '2026-11-27',
  },
  {
    week: 44,
    event: 'SEA44',
    date: '2026-12-04',
  },
  {
    week: 45,
    event: 'SEA45',
    date: '2026-12-11',
  },
]

export const WAVE_CALENDARS = [
  { id: '2026', label: '2026 Seasonal', year: 2026, offsetDays: 0 },
  { id: '2027', label: '2027 Seasonal — Demo', year: 2027, offsetDays: 364 },
]
